import { render, staticRenderFns } from "./IconCallAction.vue?vue&type=template&id=44bd733d&"
import script from "./IconCallAction.vue?vue&type=script&lang=ts&"
export * from "./IconCallAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports